'use client';

import React from 'react';
import VolumeDifferenceContent from './VolumeDifferenceContent';

const CompactVolumeDifferencePreview: React.FC = () => (
  <VolumeDifferenceContent />
);

export default CompactVolumeDifferencePreview;
